module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fBBc4AMP6lQ.709f6f90.woff2";